import { api, formatParams, config } from "@/utils/axios";
import { getToken } from "@/utils/auth";
import axios from "axios";

// 新增动态数据
export function add(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableData/${params.tableId}`,
    })
  );
}

// 分页查询动态数据
export function dataList(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableData/page/${params.tableId}?currentNo=${params.currentNo}&pageSize=${params.pageSize}`,
    })
  );
}

// 查询单条动态数据
export function getDetail(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/tableData/${params.tableId}/${params.dataId}`,
    })
  );
}

// 物理删除批量
export function del(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableData/removeBatch/${params.tableId}`,
    })
  );
}

// 查询指定表单指定字段所有数据
export function findDataAll(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableData/findDataAll`,
    })
  );
}

// 修改动态数据
export function update(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/tableData/${params.tableId}/${params.dataId}`,
    })
  );
}

// 删除所有数据
export function delAll(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/tableData/removeAll/${params.tableId}`,
    })
  );
}

// 上传文件
export function uploadFile(params) {
  return api(
    Object.assign(formatParams("POST", params, "file"), {
      url: `${config.proxy}/dynamic-form/store/upload`,
    })
  );
}

// 数据导出接口
export function exportExcel(params) {
  return axios({
    // 用axios发送post请求
    method: "post",
    url: `${config.proxy}/dynamic-form/excel/export/${params.tableId}`, // 请求地址
    data: params, // 参数
    responseType: "blob", // 表明返回服务器返回的数据类型
    headers: {
      Authorization: getToken(),
      "Content-Type": "application/json",
      appId: process.env.VUE_APP_APPID,
    },
  });
}

// 数据模版excel接口
export function exportExcelTemp(params) {
  return axios({
    method: "post",
    url: `${config.proxy}/dynamic-form/excel/importData/${params.tableId}`, // 请求地址
    data: params, // 参数
    responseType: "blob", // 表明返回服务器返回的数据类型
    headers: {
      Authorization: getToken(),
      appId: process.env.VUE_APP_APPID,
    },
  });
}

// 数据导入预览
export function importPreview(params) {
  return api(
    Object.assign(formatParams("POST", params, "file"), {
      url: `${config.proxy}/dynamic-form/excel/importPreview`,
    })
  );
}

// 数据导入预览
export function importPreviewAll(params) {
  return api(
    Object.assign(formatParams("POST", params, "file"), {
      url: `${config.proxy}/dynamic-form/excel/importPreviewAll`,
    })
  );
}

// 数据导入接口
export function importExcel(params) {
  return api(
    Object.assign(formatParams("POST", params.formData, "file", 300000), {
      url: `${config.proxy}/dynamic-form/excel/import/${params.collectionId}/${params.sheetNo}`,
    })
  );
}
